import { Routes, Route } from 'react-router-dom';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { AdminRoute } from '@/components/common/AdminRoute';
import { LoginPage } from '@/pages/auth/LoginPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { UsersPage } from '@/pages/users/UsersPage';
import { OnboardingPage } from '@/pages/onboarding/OnboardingPage';
import { AnalyticsPage } from '@/pages/analytics/AnalyticsPage';
import { ReportsPage } from '@/pages/analytics/ReportsPage';
import { RealtimePage } from '@/pages/analytics/RealtimePage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { SimpleFormPage } from '@/pages/SimpleFormPage';
import { ComprehensiveFormPage } from '@/pages/ComprehensiveFormPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { UserDetailPage } from './pages/users/UserDetails/UserDetailPage';
import KycInfo from './pages/users/Create/KycInfo';
import { UpiAccounts } from './pages/Bank/UpiAccounts';
import { DepositRequest } from './pages/Transactions/DepositRequest';
import { WithdrawRequest } from './pages/Transactions/WithdrawRequest';
import { TrusteeKycRequest } from './pages/Kyc/TrusteeKycRequest';
import MasterRwaForm from './pages/MasterRWA/MasterRWAForm';
import ChangePassword from './pages/ChangePassword';
import { ProfilePage } from './pages/Profile/ProfilePage';
import CreateUser from './pages/users/Create/CreateUser';
import { AssetList } from './pages/Asset/AssetList';
import AssetDetailsPage from './pages/Asset/AssetDetailsPage';
import NotificationListener from './components/Notification/NotificationListener';
import { Toaster } from 'react-hot-toast';
import NotificationsPage from './pages/NotificationsPage';
import TrusteeKycDetails from './pages/Kyc/TrusteeKycDetails';
import { CouponsPage } from './pages/Coupon/CouponPage';
import CreateCoupon from './pages/Coupon/CreateCoupon';
import EditAssetPage from './pages/Asset/EditAssetPage';
import { LegalComplianceVendorsPage } from './pages/Vendors/LegalComplianceVendorsPage';
import CreateCommunityPartner from './pages/Partners/CreateCommunityPartner';
import { CommunityPartners } from './pages/Partners/CommunityPartners';
import LiveStream from './pages/LiveStream';
import { ContestantPage } from './pages/Contestant/ContestantPage';
import CreateContestant from './pages/Contestant/CreateContestant';
import VotingSessions from './pages/Voting/VotingSessions';
import { ContestentDetailsPage } from './pages/Contestant/ContestentDetailsPage';
import { VotingSessionDetails } from './pages/Voting/VotingSessionDetails';

export function App() {
  return (
    <>
      {/* <NotificationListener /> */}
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          {/* <Route path="/register" element={<RegisterPage />} /> */}
        </Route>
        <Route path="/live" element={<LiveStream />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />

            {/* Analytics Routes */}
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/analytics/reports" element={<ReportsPage />} />
            <Route path="/analytics/realtime" element={<RealtimePage />} />

            {/* Settings Routes */}
            <Route path="/settings" element={<SettingsPage />} />

            {/* Form Examples */}
            <Route path="/forms" element={<SimpleFormPage />} />
            <Route path="/forms/comprehensive" element={<ComprehensiveFormPage />} />

            {/* Admin Routes */}
            <Route element={<AdminRoute />}>
              <Route path="/users/:userType" element={<UsersPage />} />
              <Route path="/user-detail/:id" element={<UserDetailPage />} />
              <Route path="/contestent-detail/:id" element={<ContestentDetailsPage />} />
              <Route path="/contestant" element={<ContestantPage />} />
              <Route path="/voting" element={<VotingSessions />} />
              <Route path="/voting-details/:sessionId" element={<VotingSessionDetails />} />
              <Route path="/create-user/:userType" element={<CreateUser />} />
              <Route path="/create-investor/kyc/:id" element={<KycInfo />} />
              <Route path="/upi" element={<UpiAccounts />} />
              <Route path="/community-partners" element={<CommunityPartners />} />
              <Route path="/add-community-partner" element={<CreateCommunityPartner />} />
              <Route path="/deposit-request" element={<DepositRequest />} />
              <Route path="/withdraw-request" element={<WithdrawRequest />} />
              <Route path="/trustee-kyc-request" element={<TrusteeKycRequest />} />
              <Route path="/trustee-kyc-details/:id" element={<TrusteeKycDetails />} />
              <Route path="/master-rwa-form" element={<MasterRwaForm />} />
              <Route path="/change-password" element={<ChangePassword />} />
              <Route path="/asset-list" element={<AssetList />} />
              <Route path="/asset-detail/:id" element={<AssetDetailsPage />} />
              <Route path="/edit-asset/:id" element={<EditAssetPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/coupon-page" element={<CouponsPage />} />
              <Route path="/create-coupon" element={<CreateCoupon />} />
              <Route path="/vendors-page" element={<LegalComplianceVendorsPage />} />
              <Route path="/create-contestant" element={<CreateContestant />} />
            </Route>
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <Toaster
        position="top-right"
        toastOptions={{
          duration: 6000,
        }}
      />
    </>
  );
}
